module.exports = __webpack_public_path__ + "img/netflix-bg.6eac9e1e.svg";